import { render, staticRenderFns } from "./detailCard.vue?vue&type=template&id=7f348edc&scoped=true"
import script from "./detailCard.vue?vue&type=script&lang=js"
export * from "./detailCard.vue?vue&type=script&lang=js"
import style0 from "./detailCard.vue?vue&type=style&index=0&id=7f348edc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f348edc",
  null
  
)

export default component.exports